var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.215,
    height: 62.485,
    viewBox: "0 0 65.215 62.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#4bd48c;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_17",
    "data-name": "Group 17",
    transform: "translate(.581 .872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape",
    d: "M51.095 0l-34.3 42.583L0 25.792",
    className: "prefix__cls-1",
    transform: "translate(12.133 1.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-2",
    d: "M59.647 23.49A30.2 30.2 0 1 1 43.618 3.146",
    className: "prefix__cls-1",
    "data-name": "Shape",
    transform: "translate(.419 .165)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.01b2035291057f84be3860580abb295e.svg";
export { ForwardRef as ReactComponent };